/**
 * URL helpers so we can flip our routing conventions in one place.
 * Prefers @username URLs for shareability; falls back to the raw id.
 */
export function creatorHref({ username, id, creator_id, creator_username } = {}) {
  const handle = username || creator_username;
  if (handle) return `/creators/@${handle}`;
  const rawId = id || creator_id;
  return rawId ? `/creators/${rawId}` : "/creators";
}

/** Prefers the readable /audios/:slug URL; falls back to the raw id. */
export function audioHref({ slug, id } = {}) {
  return `/audios/${slug || id}`;
}
